module.exports = __webpack_public_path__ + "static/media/screen6.c1fd1aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/png/screen6.png
// module id = 826
// module chunks = 4